import type React from 'react';
import { useEffect } from 'react';

export const useClosePopoverOnScrollOut = (
  triggerRef: React.RefObject<HTMLElement | null>,
  isOpen: boolean,
  setIsOpen: (open: boolean) => void,
) => {
  useEffect(() => {
    if (!isOpen || !triggerRef?.current) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          setIsOpen(false);
        }
      },
      {
        rootMargin: '-60px 0px 0px 0px', // top only — close when trigger scrolls behind header
      },
    );

    observer.observe(triggerRef.current);

    return () => {
      observer.disconnect();
    };
  }, [isOpen, setIsOpen, triggerRef]);
};
